import {Component, OnDestroy, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ActionCompletion, Actions, ofActionCompleted, Select, Store} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import ResponseHandlingHelper from '../../helpers/response-handling-helper';
import {PerpetualLicensesState} from '../../states/perpetual-licenses.state';
import {FetchPerpetualLicenses} from '../../states/perpetual-licenses.actions';
import {PerpetualLicensesModelResponse} from '../../api/responses/perpetual-licenses-response';
import {ActivatedRoute, Params} from '@angular/router';
import {PushMenuActiveAccountId} from 'src/app/states/menu.actions';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-perpetual-licenses-page',
    templateUrl: './perpetual-licenses-page.component.html',
    styleUrls: ['./perpetual-licenses-page.component.scss']
})
export class PerpetualLicensesPageComponent implements OnInit, OnDestroy {

    public accountId: number;

    @Select(PerpetualLicensesState.licenses)
    public licensesListener: Observable<PerpetualLicensesModelResponse[]>;

    public licenses: PerpetualLicensesModelResponse[] = [];

    /**
     * Określa czy aktualnie trwa pobieranie danych.
     */
    public isLoading = false;

    private gc = new Subject();

    /**
     * Token służący do anulowania pobierania danych.
     */
    private cancellationToken = new Subject();

    constructor(
        private store: Store,
        private actions: Actions,
        private route: ActivatedRoute,
        private title: Title
    ) {
    }

    public ngOnInit() {
        this.title.setTitle('Perpetual licenses - Dataedo Account');
        this.initEvents();
    }

    private fetchData() {
        this.cancellationToken.next();
        this.isLoading = true;

        this.store.dispatch(new FetchPerpetualLicenses(this.accountId, this.cancellationToken));
    }

    private initEvents() {
        this.route.params
            .pipe(takeUntil(this.gc))
            .subscribe(params => this.onPathChange(params));

        this.licensesListener
            .pipe(takeUntil(this.gc))
            .subscribe(licenses => this.licenses = licenses);

        this.actions
            .pipe(ofActionCompleted(FetchPerpetualLicenses))
            .pipe(takeUntil(this.gc))
            .subscribe(event => this.onCompletedFetchLicenses(event));
    }

    private onPathChange(params: Params) {
        this.accountId = parseInt(params.accountId, 10);
        this.store.dispatch(new PushMenuActiveAccountId(this.accountId));
        this.fetchData();
    }

    private onCompletedFetchLicenses(event: ActionCompletion<FetchPerpetualLicenses, Error>) {
        const response = ResponseHandlingHelper.parse(event.result);

        this.isLoading = false;
    }

    public trackLicenseById(index: number, license: PerpetualLicensesModelResponse): number {
        return license.id;
    }

    public ngOnDestroy(): void {
        this.cancellationToken.next();
        this.cancellationToken.complete();

        this.gc.next();
        this.gc.complete();
    }
}
